import { useLocation } from 'react-router-dom';

export const useCurrentUrl = () => {
    const { pathname, search, hash } = useLocation();
    return `${window.location.origin}${pathname}${search}${hash}`;
};
